import { render, staticRenderFns } from "./VoucherSummary.vue?vue&type=template&id=38341846&scoped=true"
import script from "./VoucherSummary.vue?vue&type=script&lang=js"
export * from "./VoucherSummary.vue?vue&type=script&lang=js"
import style0 from "./VoucherSummary.vue?vue&type=style&index=0&id=38341846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38341846",
  null
  
)

export default component.exports